module.exports = __webpack_public_path__ + "dingbeauty-landing/img/device_v2@2x.da68f374.png";